<template>
  <v-card class="mx-auto" variant="flat" max-width="300" v-if="hasReadAllDocuments">
    <!-- <v-list>
      <v-list-item>
        <router-link class="" to="/home">
          <v-img class="mt-4" src="@/assets/img/logo_color.png" height="70" contain></v-img>
        </router-link>
      </v-list-item>
    </v-list>
    <v-divider class="my-2"></v-divider> -->
    <v-list :lines="false" density="compact" nav>
      <v-list-item
        v-for="item in menuItems"
        :key="item.path"
        :active="isRouteActive(item.path)"
        link
        :to="{ name: item.path }"
        color="primary"
        variant="text"
        lines="two"
        density="compact"
        :border="true">
        <template #[`prepend`]>
          <v-icon :icon="item.icon"/>
        </template>
        <v-list-item-title class="custom-text-item-size">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import { roleManager } from '@/store/roleManager';
  import cookieManager from '@/utils/cookieManager';

  const store = useStore();
  const router = useRouter();

  const menuItems = ref([
    { title: 'HOME', path: 'HomeView', icon: 'mdi-home' },
  ]);

  const activeRoute = computed(() => store.getters.activeRoute);
  const hasReadAllDocuments = computed(() => cookieManager.hasReadAllAppDocuments());

  const controlPanelTab = () => {
    if (roleManager.isAnyAdmin()) {
      menuItems.value.push(
        { title: 'REPOSITORY', path: 'DocumentList', icon: 'mdi-file-document' },
        { title: 'ADMIN', path: 'AdminView', icon: 'mdi-cog' },
        { title: 'USER TRAIL', path: 'AuditUsers', icon: 'mdi-account-clock' },
        { title: 'FILE TRAIL', path: 'AuditDocuments', icon: 'mdi-file-document' }
      );
    }
    if (roleManager.isUploader() || roleManager.isVerifier() || roleManager.isResearcher()) {
      menuItems.value.push(
        { title: 'REPOSITORY', path: 'DocumentList', icon: 'mdi-file-document' },
      );
    }
    if (roleManager.isStaff()) {
      menuItems.value.push(
        { title: 'EVENT TRAIL', path: 'AuditEvents', icon: 'mdi-transit-connection-variant' },
      );
    }
  };

  const isRouteActive = (path) => activeRoute.value === router.resolve({ name: path }).fullPath;

  onMounted(() => {
    controlPanelTab();
  });
</script>

<style scoped lang="scss">
  .logo {
    margin-top: 0;
  }
  .align-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-text-item-size {
    font-size: 1em;
    font-weight: 600;
  }
  .v-list.v-list--nav > a.v-list-item {
     &.v-list-item--active {
       border-color: var(--v-primary-primary);
     }
     &:not(.v-list-item--active) {
      border: none;
     }
  }
</style>
